export const statusColumns = {
  SUBMITTED: 'SUBMITTED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED_POSITIVE: 'COMPLETED_POSITIVE',
  COMPLETED_NEGATIVE: 'COMPLETED_NEGATIVE',
  READY_FOR_SIGN_POSITIVE: 'READY_FOR_SIGN_POSITIVE',
  READY_FOR_SIGN_NEGATIVE: 'READY_FOR_SIGN_NEGATIVE',
  IN_PROGRESS_IN_EXTERNAL_APP: 'IN_PROGRESS_IN_EXTERNAL_APP'
};
